import { render, staticRenderFns } from "./Attr.vue?vue&type=template&id=5a43f1a4"
import script from "./Attr.vue?vue&type=script&lang=js"
export * from "./Attr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports